import { X, Phone, Mail, Download } from 'lucide-react';

interface HelpDialogProps {
  onClose: () => void;
}

export function HelpDialog({ onClose }: HelpDialogProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            Need Help?
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1 rounded-lg transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-6">
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-gray-100">Contact Us</h4>
            <a
              href="tel:844-210-8444"
              className="flex items-center gap-3 text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400"
            >
              <Phone className="h-5 w-5" />
              844-210-8444
            </a>
            <a
              href="mailto:info@fieldy.io"
              className="flex items-center gap-3 text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400"
            >
              <Mail className="h-5 w-5" />
              info@fieldy.io
            </a>
          </div>

          <div className="border-t border-gray-200 dark:border-gray-700 pt-6 space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-gray-100">Install as App</h4>
            <div className="text-gray-600 dark:text-gray-300 space-y-2">
              <p className="flex items-center gap-2">
                <Download className="h-5 w-5" />
                Install Worker Panel for easier access
              </p>
              <div className="text-sm space-y-2">
                <p><strong>On iPhone:</strong></p>
                <ol className="list-decimal list-inside space-y-1 pl-2">
                  <li>Tap the Share button</li>
                  <li>Scroll down and tap "Add to Home Screen"</li>
                  <li>Tap "Add" to confirm</li>
                </ol>
                
                <p className="mt-3"><strong>On Android:</strong></p>
                <ol className="list-decimal list-inside space-y-1 pl-2">
                  <li>Tap the menu (3 dots)</li>
                  <li>Tap "Add to Home screen"</li>
                  <li>Tap "Add" to confirm</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}